import { MedicalRecordFile } from 'types/medicalRecord.types';

export function getOcrText(record?: MedicalRecordFile) {
  return record?.ocrText
    ? Object.keys(record.ocrText)
        .map((k) => Number(k))
        .sort()
        .map((k) => record.ocrText![`${k}`])
        .join(' ')
    : undefined;
}
